import React from 'react'

import File from '@peracto/peracto-editor-ui/dist/File'
import Checkbox from '@peracto/peracto-editor-ui/dist/Checkbox'

const VideoForm = ({
    onChange,
    state: {
        url = '',
        poster = '',
        playsInline = false,
        autoPlay = false,
        loop = false,
        controls = false,
        showControlsOnHover = false,
        muted = false,
    },
}) => {
    return (
        <>
            <File label="Video URL" value={url} onChange={value => onChange({ url: value })} />

            <File
                label="Video thumbnail"
                value={poster}
                onChange={value => onChange({ poster: value })}
            />

            <Checkbox
                label="Autoplay"
                checked={autoPlay}
                help={
                    autoPlay
                        ? 'Autoplaying videos are always muted and play inline, as browsers block autoplay otherwise.'
                        : ''
                }
                // Mute and Play Inline aren't written here: while autoplay is on they're shown
                // as locked on and forced by the renderer, so unticking autoplay restores them
                onChange={e => onChange({ autoPlay: e.target.checked })}
            />

            <Checkbox
                label="Loop"
                checked={loop}
                onChange={e => onChange({ loop: e.target.checked })}
            />

            <Checkbox
                label="Mute"
                checked={autoPlay || muted}
                disabled={autoPlay}
                onChange={e => onChange({ muted: e.target.checked })}
            />

            <Checkbox
                label="Play Inline"
                checked={autoPlay || playsInline}
                disabled={autoPlay}
                onChange={e => onChange({ playsInline: e.target.checked })}
            />

            {/* Show Controls and Show Controls On Hover are mutually exclusive */}
            <Checkbox
                label="Show Controls"
                checked={controls}
                onChange={e =>
                    onChange(
                        e.target.checked
                            ? { controls: true, showControlsOnHover: false }
                            : { controls: false }
                    )
                }
            />

            <Checkbox
                label="Show Controls On Hover"
                checked={showControlsOnHover}
                help="On touch devices, controls are shown when the video is tapped."
                onChange={e =>
                    onChange(
                        e.target.checked
                            ? { showControlsOnHover: true, controls: false }
                            : { showControlsOnHover: false }
                    )
                }
            />
        </>
    )
}

export default VideoForm
